import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GlobalLookupsCollections } from '../../api/models';
// import { GlobalLookupsCollections, GlobalLookupsEntry } from '../../api/models';

export interface ListsType extends GlobalLookupsCollections {
	// roleCategories?: Array<GlobalLookupsEntry>;
}

const initialState: ListsType = {
	// roleCategories: [
	// 	{
	// 		label: 'Staff Member',
	// 		value: 'staffmember'
	// 	},
	// 	{
	// 		label: 'Parent or Guardian',
	// 		value: 'parentorguardian'
	// 	},
	// 	{
	// 		label: 'Child or Student',
	// 		value: 'childorstudent'
	// 	},
	// 	{
	// 		label: 'Site Visitor',
	// 		value: 'sitevisitor'
	// 	}
	// ]
};

export const ListsSlice = createSlice({
	name: 'lists',
	initialState,
	reducers: {
		update: (state, action: PayloadAction<ListsType>) => {
			state = Object.assign(state, action.payload);
		}
	}
});

export default ListsSlice;
